import { createFileRoute } from '@tanstack/react-router';
import { NotesSection } from '@/features/Lesson/NotesSection';
import { useTopicDetail } from '@/lib/hooks/useLms';

export const Route = createFileRoute('/_student/courses/$batchId/topics/$topicId/notes')({
  component: NotesRoute,
});

function NotesRoute() {
  const { topicId } = Route.useParams();
  const { data: topic } = useTopicDetail(topicId);
  if (!topic) return null;
  return <NotesSection topicId={topicId} notes={topic.notes} />;
}
